<h3 mat-dialog-title>
  CANCEL CASE - <strong>{{ data?.caseDetails.caseNumber }}</strong>
</h3>
<mat-dialog-content>
  <form [formGroup]="cancelForm">
    <mat-form-field appearance="outline" style="width: 100%">
      <mat-label>Cancellation Notes</mat-label>
      <textarea
        matInput
        formControlName="notes"
        placeholder="Enter cancellation notes"
        required>
      </textarea>
      <mat-error *ngIf="cancelForm.get('notes').hasError('required')">
        Notes are required.
      </mat-error>
      <mat-error *ngIf="cancelForm.get('notes').hasError('pattern')">
        Enter valid cancellation notes.
      </mat-error>
    </mat-form-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button (click)="onCancel()">Cancel</button>
  <button
    mat-stroked-button
    color="warn"
    [disabled]="cancelForm.invalid"
    (click)="onConfirm()">
    Confirm
  </button>
</mat-dialog-actions>
